import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, ArrowLeft } from "lucide-react";
import { forgotPassword } from "../../lib/adminApi";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email);
    } catch (_) {
      // always show the same confirmation — never reveal account existence
    } finally {
      setDone(true);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF8F3] flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        data-testid="admin-forgot-form"
        className="bg-white border border-[#E7E2D9] p-10 w-full max-w-md shadow-[0_24px_60px_-30px_rgba(17,17,17,0.18)]"
      >
        <img src="/logo.png" alt="Zarco's Decks" className="h-16 w-auto mb-8" />
        <h1 className="font-display text-3xl tracking-tight text-[#111]">Reset password</h1>
        {done ? (
          <p className="mt-4 text-sm text-[#4A4A4A] leading-relaxed" data-testid="admin-forgot-confirmation">
            If that email matches the admin account, a password reset link is on its way.
            The link is valid for 60 minutes.
          </p>
        ) : (
          <>
            <p className="mt-2 text-sm text-[#4A4A4A]">
              Enter the admin email and we'll send a reset link.
            </p>
            <label className="block mt-8 text-[11px] uppercase tracking-[0.2em] font-semibold">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-forgot-email"
              className="mt-2 w-full border-b-2 border-[#E7E2D9] focus:border-[#99582A] py-3 outline-none"
            />
            <button
              disabled={loading}
              data-testid="admin-forgot-submit-btn"
              className="mt-8 w-full bg-[#111] hover:bg-[#99582A] transition-colors text-white py-4 font-semibold tracking-wide flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading ? <Loader2 size={16} className="animate-spin" /> : <Mail size={16} />}
              Send reset link
            </button>
          </>
        )}
        <Link
          to="/admin/login"
          data-testid="admin-forgot-back-link"
          className="mt-6 inline-flex items-center gap-2 text-sm text-[#4A4A4A] hover:text-[#99582A]"
        >
          <ArrowLeft size={14} /> Back to sign in
        </Link>
      </form>
    </div>
  );
}
